module.exports = __webpack_public_path__ + "static/media/ad.f929a811.svg";